import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';


export interface ChatQuestionCard {
	title: string,
	thumbnail?: string;
}

@Component({
  selector: 'app-chat-question-card',
  templateUrl: './chat-question-card.component.html',
  styleUrls: ['./chat-question-card.component.scss']
})
export class ChatQuestionCardComponent implements OnInit {

  	@Input() type: 'horizontal' | 'vertical' | 'minimal' = 'horizontal';
	@Input() data: any;
	@Output() detail: any = new EventEmitter();
	@Output() users = new EventEmitter<boolean>();
	@Output() profile: any = new EventEmitter();
	@Output() remove: any = new EventEmitter();
	@Output() action: any = new EventEmitter();
	@Output() forwarderUser: any = new EventEmitter();


  cardData;

  constructor(
    public locale: LocaleService,
		public gfService: GlobalFunctionService
  ) { }

  ngOnInit(): void { }

  close(data) {
		if (navigator.onLine) {
			this.remove.emit(data);
		}
	}

	info(data) {
		if (navigator.onLine) {
			this.detail.emit(data);
		}
	}

	profileInfo(data) {
		if (navigator.onLine) {
			this.profile.emit(data);
		}
	}

	usersInfo() {
		if (navigator.onLine) {
			this.users.emit(true);
		}
	}

	actionInfo(action) {
		if (navigator.onLine) {
			this.action.emit(action);
		}
	}

	forwarderUserInfo(data) {
		if (navigator.onLine) {
			this.forwarderUser.emit(data);
		}
	}

}
